<template>
    <div class="">
        <div class="w-full" style="width: 100%">
            <checkout-select-payment
                :payment-options="paymentMethods"
                :id-lang="idLang"
                :id-shop="idShop"
                :remembered-provider="rememberedProvider"
                @payment-method-selected="idPaymentMethod = $event"
            ></checkout-select-payment>
        </div>

        <div class="w-full" style="width: 100%">
            <checkout-address
                :addresses="addresses"
                :id-lang="idLang"
                :id-shop="idShop"
                :id-address-delivery="idAddressDelivery"
                :id-address-invoice="idAddressInvoice"
                :add-new-address-link="urls.AddressAddNewAddressLink"
                :get-address-link="urls.AddressGetAddressLink"
                :countries="countries"
                :default-country-id="idCountry"
                :back-link="urls.AddressBackLink"
                :change-order-address-link="urls.AddressChangeOrderAddressLink"
                @passes-validation-changed="checkoutAddressPassesValidation = $event"
                @selected-delivery-address-changed="deliveryAddressChangeEvent"
                @selected-invoice-address-changed="selectedInvoiceAddress = $event ? $event.id_address : null"
                @addresses-list-changed="addresses = $event"
            ></checkout-address>
        </div>

        <div class="w-full" style="width: 100%">
            <checkout-remember-payment>

            </checkout-remember-payment>
        </div>

        <!-- Values -->
        <input type="hidden" name="id_payment_method" :value="idPaymentMethod">
        <input type="hidden" name="emailoptin" :value="emailOptIn">

        <!-- Only used for remembering the addresses -->
        <input type="hidden" name="id_delivery_address" :value="selectedDeliveryAddress">
        <input type="hidden" name="id_invoice_address" :value="selectedInvoiceAddress">

        <input type="hidden" name="submitCheckout" value="true">
        <!-- /Values -->

    </div>
</template>
<script>
import CheckoutAddress from "./CheckoutAddress";
import CheckoutSelectPayment from "./CheckoutSelectPayment";
import CheckoutRememberPayment from "./CheckoutRememberPayment";

export default {
    name: "CheckoutPaymentStep",
    components: { CheckoutSelectPayment, CheckoutAddress, CheckoutRememberPayment },
    props: {
        idLang: {
            type: Number,
            required: true,
        },
        idShop: {
            type: Number,
            required: true,
        },
        idAddressDelivery: {
            type: Number,
            required: true,
        },
        idAddressInvoice: {
            type: Number,
            required: true,
        },
        idCountry: {
            type: Number,
            required: true,
        },
        countries: {
            type: Array,
            required: true
        },
        propAddresses: {
            type: Array,
            required: true
        },
        paymentMethods: {
            type: Array,
            required: true
        },
        rememberedProvider: {
            type: String,
            required: false,
        },
        ga4Data: {
            type: Object,
            required: false,
            validator: (value) => {
                const requiredKeys = ["products", "cartTotalWt", "currency"];
                let hasMissingKey = false;

                requiredKeys.forEach((key) => {
                    if (! (key in value)) {
                        console.warn(`Missing ${key} key in CheckoutPaymentStep ga4Data prop`);

                        hasMissingKey = true;
                    }
                });

                return ! hasMissingKey;
            }
        },
        urls: {
            type: Object,
            required: true,
            validator: (value) => {
                const requiredKeys = ["AddressAddNewAddressLink", "AddressChangeOrderAddressLink", "AddressGetAddressLink", "AddressBackLink"];
                let hasMissingKey = false;

                requiredKeys.forEach((key) => {
                    if (! (key in value)) {
                        console.warn(`Missing ${key} key in CheckoutPaymentStep urls prop`);

                        hasMissingKey = true;
                    }
                });

                return ! hasMissingKey;
            }
        }
    },
    data() {
        return {
            addresses: [],
            idPaymentMethod: null,
            emailOptIn: true,
            csvAccepted: false,
            selectedDeliveryAddress: null,
            selectedInvoiceAddress: null,
            checkoutAddressPassesValidation: false
        }
    },
    beforeMount() {
        this.addresses = this.propAddresses;
    },
    methods: {
        deliveryAddressChangeEvent(event) {
            const idAddress = event ? event.id_address : null;

            this.selectedDeliveryAddress = idAddress;
            window.EventBus.$emit('checkout-delivery-address-changed', idAddress);
        },
        pushGAEvent(event, data) {
            if (typeof window.pushGAEvent === 'function') {
                window.pushGAEvent(event, data);
            }
        },
        getSelectedDeliveryAddress() {
            return this.addresses.find((address) => (
                address.id_address === this.selectedDeliveryAddress && address.active
            ));
        }
    },
    watch: {
        validationMessages: {
            immediate: true,
            handler(validationMessage) {
                const hasErrors             = !!validationMessage;
                const checkoutErrorElements = document.querySelectorAll('.checkout_error_text');

                checkoutErrorElements.forEach((checkoutErrorElement) => {
                    if (!hasErrors) {
                        checkoutErrorElement.style.display = 'none';
                    }

                    checkoutErrorElement.querySelector("div").innerText = this.validationMessages;
                });

                document.getElementsByName('submitNewCheckout').forEach((submitCheckout) => {
                    const isAddressRequiresPhoneMessage = this.validationMessages === this.$t('checkout.validationErrors.paymentMethodRequiresPhoneNumber');

                    submitCheckout.setAttribute('submit-error', hasErrors ? this.validationMessages : "");
                    submitCheckout.setAttribute('show-phone-required-modal', String(isAddressRequiresPhoneMessage));
                    hasErrors ? submitCheckout.classList.remove('js-hook-submit-checkout') : submitCheckout.classList.add('js-hook-submit-checkout');
                });
            }
        },
        idPaymentMethod: {
            handler(payment_method) {
                if (! payment_method) {
                    return;
                }

                this.pushGAEvent("add_payment_info", {
                    currency: this.ga4Data.currency,
                    value: this.ga4Data.cartTotalWt,
                    payment_type: payment_method,
                    items: this.ga4Data.products
                });
            }
        },
        selectedDeliveryAddress: {
            handler(address) {
                this.pushGAEvent("add_shipping_info", {
                    currency: this.ga4Data.currency,
                    value: this.ga4Data.cartTotalWt,
                    items: this.ga4Data.products
                });
            }
        },
        selectedInvoiceAddress: {
            handler(address) {
                this.pushGAEvent("add_invoice_info", {
                    currency: this.ga4Data.currency,
                    value: this.ga4Data.cartTotalWt,
                    items: this.ga4Data.products
                });
            }
        }
    },
    computed: {
        deliveryAddressHasPhoneNumber() {
            return !! this.addresses.filter((address) => (
                Number(address.id_address) === Number(this.selectedDeliveryAddress) &&
                !!address.phone
            )).length;
        },
        validationMessages() {
            const selectedAddress = this.getSelectedDeliveryAddress();

            if (!this.idPaymentMethod) {
                return this.$t('checkout.validationErrors.noPaymentMethodSelected')
            }

            if (! this.checkoutAddressPassesValidation) {
                // No delivery in this region message for DK
                if (this.idCountry === 20 && selectedAddress && selectedAddress.no_shipping) {
                    return this.$t('checkout.validationErrors.noDeliveryOnThisAddress')
                }
                return this.$t('checkout.validationErrors.noAddressSelected')
            }

            if (this.idPaymentMethod === "KLARNA" && ! this.deliveryAddressHasPhoneNumber) {
                return this.$t('checkout.validationErrors.paymentMethodRequiresPhoneNumber')
            }

            if (! this.csvAccepted && this.idCountry === 1) {
                return this.$t('checkout.validationErrors.termsOfServices')
            }

            return null;
        }
    },
    mounted() {
        const emailOptInCheckboxes = document.querySelectorAll('input[type="checkbox"][name="emailoptin"]');

        emailOptInCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', (e) => {
            this.emailOptIn = e.currentTarget.checked;
        }));
        const cgvCheckboxes = document.querySelectorAll('input[type="checkbox"][name="cgv"]');

        cgvCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', (e) => {
            this.csvAccepted = e.currentTarget.checked;
        }));
    }
}
</script>
